<template>
  <div class="form-row form-with-table">
    <form :class="{ 'loading-opacity': preloader, 'col-sm-12 p-4': isAdmin, 'col-md-12 mb-0': !isAdmin } ">
      <div class="d-flex flex-wrap">
        <div class="form-group mb-3 col-md-6 col-md-12">
          <h3 class="text-center mb-0">
            Basic Information Details
          </h3>
        </div>
        <div class="form-group mb-3 col-md-6 align-items-center">
          <label class="col-sm-12 mb-2">Forename</label>
          <app-input class="col-sm-12"
                     type="text"
                     :required="true"
                     @keyup="(event) => textOnChange(event, 'forename', validationType.Alphabet)"
                     v-model="basic_info.forename"
                     placeholder="Forename"
          />
          <div class="error col-sm-12" v-if="!validation.forename">
            {{ $t('forename_error') }}
          </div>
        </div>
        <div class="form-group mb-3 col-md-6 align-items-center">
          <label class="col-sm-12 mb-2">
            Middle Name
          </label>
          <app-input class="col-sm-12"
                     type="text"
                     @keyup="(event) => textOnChange(event, 'middle_name', validationType.Alphabet)"
                     :required="true"
                     v-model="basic_info.middle_name"
                     placeholder="Middle Name"
          />
        </div>
        <div class="form-group mb-3 col-md-6 align-items-center">
          <label class="col-sm-12 mb-2">Surname </label>
          <app-input class="col-sm-12"
                     type="text"
                     @keyup="(event) => textOnChange(event, 'surname', validationType.Alphabet)"
                     v-model="basic_info.surname"
                     placeholder="Surname"
                     :required="true"
          />
        </div>
        <div class="form-group mb-3 col-md-6 align-items-center">
          <label class="col-sm-12 mb-2">Title </label>
          <app-input class="col-sm-12"
                     type="select"
                     :list="titleList"
                     v-model="basic_info.title"
                     placeholder="Select title"
                     :required="true"/>
        </div>
        <div class="form-group mb-3 col-md-6 align-items-center">
          <label class="col-sm-12 mb-2">N.I. Number <b class="text-danger"> *</b></label>
          <app-input class="col-sm-12"
                     type="text"
                     :max-length=9
                     v-model="basic_info.n_i_number"
                     @keyup="(event) => textOnChange(event, 'n_i_number', validationType.AlphaNumeric)"
                     placeholder="NI Number"
          />
        </div>
        <div class="form-group mb-3 col-md-6 align-items-center">
          <label class="col-sm-12 mb-2">Gender: <b class="text-danger"> *</b></label>
          <app-input class="col-sm-12"
                     type="select"
                     :list="genderList"
                     v-model="basic_info.gender"
                     placeholder="Gender"
                     :required="true"/>
        </div>
        <div class="form-group mb-3 col-md-6 align-items-center" v-if="isAdmin">
          <label class="col-sm-12 mb-2">D.O.B: </label>
          <app-input class="col-sm-12"
                     type="date"
                     :max-date="today"
                     v-model="basic_info.date_of_birth"
                     placeholder=""
          />
        </div>
        <div class="form-group mb-3 col-md-6 align-items-center" v-if="isAdmin">
          <label class="col-sm-12 mb-2">Town of birth: </label>
          <app-input class="col-sm-12"
                     type="text"
                     v-model="basic_info.town_of_birth"
                     placeholder=""
          />
        </div>
        <div class="form-group mb-3 col-md-6 align-items-center" v-if="isAdmin">
          <label class="col-sm-12 mb-2">Country of birth: </label>
          <app-input class="col-sm-12"
                     type="text"
                     :max-date="today"
                     v-model="basic_info.country_of_birth"

          />
        </div>
        <div class="form-group mb-3 col-md-6 align-items-center">
          <label class="col-sm-12 mb-2">Nationality <b class="text-danger"> *</b></label>
          <app-input class="col-sm-12"
                     type="select"
                     :list="countryList"
                     v-model="basic_info.nationality"
                     placeholder="Nationality"/>
        </div>
        <div class="form-group mb-3 col-md-6 align-items-center">
          <label class="col-sm-12 mb-2">EDBS Number (12 - Digits)</label>
          <app-input class="col-sm-12"
                     type="text"
                     @keyup="(event) => textOnChange(event, 'edbs_number', validationType.Numeric, 12)"
                     v-model="basic_info.edbs_number"
                     placeholder="EDBS Number"/>
        </div>
        <div class="form-group mb-3 col-md-6 align-items-center">
          <label class="col-sm-12 mb-2">Contact No.</label>
          <app-input class="col-sm-12"
                     type="tel-input-custom"
                     @keyup="(event) => textOnChange(event, 'contact_number', validationType.Numeric)"

                     v-model="basic_info.contact_number"
                     placeholder="Contact No"/>
        </div>
        <div class="form-group mb-3 col-md-6 align-items-center">
          <label class="col-sm-12 mb-2">Alternative Contact No.</label>
          <app-input class="col-sm-12"
                     type="tel-input-custom"
                     @keyup="(event) => textOnChange(event, 'alternative_contact_no', validationType.Numeric)"
                     v-model="basic_info.alternative_contact_no"
                     placeholder="Alternative Contact Number"/>
        </div>
        <div class="form-group mb-3 col-md-6 align-items-center">
          <label class="col-sm-12 mb-2">Email</label>
          <app-input class="col-sm-12"
                     type="email"
                     @keyup="(event) => textOnChange(event, 'email', validationType.Email)"

                     v-model="basic_info.email"
                     placeholder="Email"
                     :read-only="true"
          />
        </div>
        <div class="form-group mb-3 col-md-6 align-items-center">
          <label class="col-sm-12 mb-2">Next of Kin <b class="text-danger"> *</b></label>
          <app-input class="col-sm-12"
                     type="text"
                     v-model="basic_info.next_of_kin"
                     @keyup="(event) => textOnChange(event, 'next_of_kin', validationType.Alphabet)"
                     placeholder="Next of kin"/>
        </div>
        <div class="form-group mb-3 col-md-6 align-items-center">
          <label class="col-sm-12 mb-2">Relationship <b class="text-danger"> *</b></label>
          <app-input class="col-sm-12"
                     type="select"
                     @keyup="(event) => textOnChange(event, 'relationship', validationType.Alphabet)"
                     :list="relationShipTypeList"
                     v-model="basic_info.relationship"
                     placeholder="Relationship with kin"/>
        </div>
        <div class="form-group mb-3 col-md-6 align-items-center">
          <label class="col-sm-12 mb-2">Next of Kin Contact No. <b class="text-danger"> *</b></label>
          <app-input class="col-sm-12"
                     type="tel-input-custom"
                     @keyup="(event) => textOnChange(event, 'next_of_kin_contact_no', validationType.Numeric)"

                     v-model="basic_info.next_of_kin_contact_no"
                     placeholder="Next of kin contact number"/>
        </div>
        <div class="form-group mb-3 col-md-6 align-items-center">
          <label class="col-sm-12 mb-2">Applicant Picture <b class="text-danger"> *</b></label>

          <!-- File Input -->
          <app-input class="col-sm-12"
                     type="file"
                     v-model="basic_info.employee_picture"
                     v-on:change="employeePictureChange"/>

          <!-- Image Preview -->
          <div v-if="employeeImagePreview" class="mt-3">
            <img :src="employeeImagePreview" alt="Employee Picture" class="img-fluid" style="max-width: 100%; height: 150px; border: 1px solid #ccc; padding: 5px;">
          </div>
        </div>

        <hr>
        <template>
          <div class="form-group mb-3 col-md-6 col-md-12">
            <h3 class="text-center mb-0">
              Licenses (SIA/Driving/Others)
            </h3>
          </div>
          <div>
            <!-- License List -->
            <div v-for="(license, index) in licenses" :key="index" class="row mb-4">
              <!-- License Type -->
              <div class="form-group mb-3 col-md-6">
                <label>License Type <b class="text-danger"> *</b></label>
                <app-input
                    type="select"
                    :list="licenseOptions"
                    v-model="license.type"
                    placeholder="Select License"
                />
              </div>
              <!-- License No -->
              <div class="form-group mb-3 col-md-6">
                <label>License Number</label>
                <app-input
                    :type="licenseTypeFieldType(license.type)"
                    v-model="license.number"
                    placeholder="Enter License Number"
                />
              </div>
              <!-- Issue Date -->
              <div class="form-group mb-3 col-md-6">
                <label>Issue Date</label>
                <app-input
                    type="date"
                    v-model="license.issueDate"
                    :max-date="today"
                    placeholder="Select Issue Date"
                />
              </div>
              <!-- License Expiry -->
              <div class="form-group mb-3 col-md-6">
                <label>License Expiry</label>
                <app-input
                    type="date"
                    v-model="license.expiry"
                    :min-date="today"
                    placeholder="Select Expiry Date"
                />
              </div>

              <!-- Remove Button -->
              <div class="form-group mb-3 col-md-12 text-end">
                <button class="btn btn-danger" @click.prevent="removeLicense(index)">Remove</button>
              </div>
            </div>

            <!-- Add License Button -->
            <div class="form-group mb-3">
              <button class="btn btn-primary" @click.prevent="addLicense" :disabled="!availableLicenses.length">
                Add License
              </button>
            </div>
          </div>
        </template>

        <hr>
        <div class="form-group mb-3 col-md-6 col-md-12">
          <h3 class="text-center mb-0">
            Right to Work
          </h3>
        </div>

        <div class="form-group mb-3 col-md-6 align-items-center">
          <label class="col-sm-12 mb-2">Do you need visa to work or remain in the UK?</label>
          <app-input class="col-sm-12"
                     type="radio"
                     :list="yesOrNoList"
                     v-model="basic_info.is_visa_require_uk" />
        </div>
        <div class="form-group mb-3 col-md-6 align-items-center" v-if="basic_info.is_visa_require_uk === 'no'">
          <label class="col-sm-12 mb-2">Upload proof of right to work (Passport / Birth Certificate)</label>

          <!-- File Input -->
          <app-input class="col-sm-12"
                     type="file"
                     v-model="basic_info.passport"
                     v-on:change="passportPictureChange"/>

        </div>

        <template v-if="basic_info.is_visa_require_uk === 'yes'">
          <div class="form-group mb-3 col-md-12 align-items-center">
            <label class="col-sm-12 mb-2">Visa Type</label>
            <app-input class="col-sm-12"
                       type="select"
                       :list="visaTypeList"
                       v-model="basic_info.visa_type"
                       placeholder=""
            />
          </div>
          <div class="form-group mb-3 col-md-6 align-items-center">
            <label class="col-sm-12 mb-2">Visa Expiry</label>
            <app-input class="col-sm-12"
                       type="date"
                       :min-date="today"
                       v-model="basic_info.visa_expiry"
                       placeholder=""
            />
          </div>
          <div class="form-group mb-3 col-md-6 align-items-center">
            <label class="col-sm-12 mb-2">Date of Entry / Re-Entry</label>
            <app-input class="col-sm-12"
                       type="date"
                       :max-date="today"
                       v-model="basic_info.date_of_entry_re_entry"
                       placeholder=""
            />
          </div>
          <div class="form-group mb-3 col-md-6 align-items-center">
            <label class="col-sm-12 mb-2">{{ $t('Biometric Residence Permit Number (BRP) Number') }}</label>
            <app-input class="col-sm-12"
                       type="text"
                       @keyup="(event) => textOnChange(event, 'biometric_residence_permit', validationType.AlphaNumeric)"
                       :max-length=9
                       v-model="basic_info.biometric_residence_permit"
                       placeholder=""/>
          </div>
          <div class="form-group mb-3 col-md-6 align-items-center">
            <label class="col-sm-12 mb-2">Share Code
            <span class="ml-3">
              <a href="https://right-to-work.service.gov.uk/rtw-prove/id-question" target="_blank">Generate Share Code</a>
            </span>
            </label>
            <app-input class="col-sm-12"
                       type="text"
                       :max-length=9
                       @keyup="(event) => textOnChange(event, 'share_code', validationType.AlphaNumeric)"
                       v-model="basic_info.share_code"
                       placeholder=""/>
          </div>
          <div class="form-group mb-3 col-md-6 align-items-center">
            <label class="col-sm-12 mb-2">Share Code Expiry Date</label>
            <app-input class="col-sm-12"
                       type="date"
                       v-model="basic_info.share_code_start_date"
                       placeholder=""/>
          </div>
        </template>
        <div class="form-group mb-3 col-md-6 align-items-center">
          <label class="col-sm-12 mb-2">Are you currently employed?</label>
          <app-input class="col-sm-12"
                     type="radio"
                     :list="yesOrNoList"
                     v-model="basic_info.is_other_employment"/>
        </div>
        <template v-if="basic_info.is_other_employment === 'yes'">
          <div class="form-group mb-3 col-md-12 align-items-center">
            <label class="col-sm-12 mb-2">
              Would you continue other employment, if you were successful in obtaining
              employment with us?
            </label>
            <app-input class="col-sm-12"
                       type="text"
                       @keyup="(event) => textOnChange(event, 'continue_other_employment', validationType.Alphabet)"
                       v-model="basic_info.continue_other_employment"
                       placeholder=""
            />
          </div>
        </template>
        <hr>



        <!--        <div class="form-group mb-3 col-md-6 col-md-12">-->
        <!--          <h3 class="text-center mb-0">-->
        <!--            Other Information-->
        <!--          </h3>-->
        <!--        </div>-->


        <div class="form-group mb-3 col-md-6 col-md-12">
          <h3 class="text-center mb-0">
            Others
          </h3>
        </div>
        <div class="form-group mb-3 col-md-6 align-items-center">
          <label class="col-sm-12 mb-2">Any Criminal Record?</label>
          <app-input class="col-sm-12"
                     type="radio"
                     :list="yesOrNoList"
                     v-model="basic_info.is_criminal_record"/>
        </div>
        <template v-if="basic_info.is_criminal_record === 'yes'">
          <div class="form-group mb-3 col-md-12 align-items-center">
            <label class="col-sm-12 mb-2">Criminal Record</label>
            <app-input class="col-sm-12"
                       type="text"
                       @keyup="(event) => textOnChange(event, 'criminal_record_details', validationType.Alphabet)"
                       v-model="basic_info.criminal_record_details"
                       placeholder=""
            />
          </div>
        </template>
        <div class="form-group mb-3 col-md-6 align-items-center">
          <label class="col-sm-12 mb-2">Any Bankruptcy (or) CCJ in last 6 years?</label>
          <app-input class="col-sm-12"
                     type="radio"
                     :list="yesOrNoList"
                     v-model="basic_info.is_bankruptcy"/>
        </div>
        <template v-if="basic_info.is_bankruptcy === 'yes'">
          <div class="form-group mb-3 col-md-12 align-items-center">
            <label class="col-sm-12 mb-2">Bankruptcy (or) CCJ Record</label>
            <app-input class="col-sm-12"
                       type="text"
                       @keyup="(event) => textOnChange(event, 'bankruptcy_details', validationType.Alphabet)"
                       v-model="basic_info.bankruptcy_details"
                       placeholder=""
            />
          </div>
        </template>
        <div class="form-group mb-3 col-md-6 align-items-center">
          <label class="col-sm-12 mb-2">Any days/ hours/shifts you can’t work?</label>
          <app-input class="col-sm-12"
                     type="radio"
                     :list="yesOrNoList"
                     v-model="basic_info.is_days_shift_cant_work"/>
        </div>
        <template v-if="basic_info.is_days_shift_cant_work === 'yes'">
          <div class="form-group mb-3 col-md-12 align-items-center">
            <label class="col-sm-12 mb-2">Shift Unavailability</label>
            <app-input class="col-sm-12"
                       type="text"
                       v-model="basic_info.days_shift_cant_work_details"
                       placeholder=""
            />
          </div>
        </template>
        <div class="form-group mb-3 col-md-6 align-items-center">
          <label class="col-sm-12 mb-2">Do you have any holidays commitment in the future?</label>
          <app-input class="col-sm-12"
                     type="radio"
                     :list="yesOrNoList"
                     v-model="basic_info.is_holidays_commitment"/>
        </div>
        <template v-if="basic_info.is_holidays_commitment === 'yes'">
          <div class="form-group mb-3 col-md-12 align-items-center">
            <label class="col-sm-12 mb-2">Details of holidays commitment in the future.</label>
            <app-input class="col-sm-12"
                       type="text"
                       v-model="basic_info.holidays_commitment_details"
                       placeholder=""
            />
          </div>
        </template>
        <div class="form-group mb-3 col-md-6 align-items-center">
          <label class="col-sm-12 mb-sm-2">Do you have access to your own transport?</label>
          <app-input type="radio"
                     class="col-sm-12 mb-2"
                     :list="yesOrNoList"
                     v-model="basic_info.is_own_vehicles"/>
        </div>




        <div class="form-group mb-3 col-md-6 align-items-center">
          <label class="col-sm-12 mb-2">Hobbies?</label>
          <app-input class="col-sm-12"
                     type="radio"
                     :list="yesOrNoList"
                     v-model="basic_info.is_leisure"/>
        </div>
        <template v-if="basic_info.is_leisure === 'yes'">
          <div class="form-group mb-3 col-md-12 align-items-center">
            <label class="col-sm-12 mb-2">Please note your leisure interest and hobbies.</label>
            <app-input class="col-sm-12"
                       type="text"
                       v-model="basic_info.leisure_details"
                       placeholder=""
            />
          </div>
        </template>
      </div>
    </form>
    <form class="col-sm-12" v-if="isAdmin">
      <div class="col-md-6 ">

        <drawer-component title="Comments" size="70%">
          <general-comments
              :comments="basic_info.screening_status"
              :emailAddress="basic_info.email"
              :applicantId="candidateId"
              :statusable_type="basic_info.statusable_type"
              :statusable_id="basic_info.id"/>
        </drawer-component>
      </div>
    </form>
  </div>
</template>

<script>
import {File} from "@Views/Screening/utility/apiAgent";
import {FormMixin} from "@/core/mixins/form/FormMixin";
import {
  genderList,
  countryList,
  siaLicenseTypeList,
  visaTypeList,
  employmentDetailsTypeList,
  p46List,
  drivingLicenseTypeList
} from "@Views/Screening/utility/constant";
import {validateAlphabet, validateAlphaNumericSixteenCharacter, validateNumeric} from "@Views/Screening/utility/common/candidate";
import {validateAlphaNumeric} from "@Views/Screening/utility/common/candidate";
import {validationType} from "@Views/Screening/utility/enums";
import {relationShipTypeList, titleList} from "@Views/Screening/utility/constant/candidate";

export default {
  name: "BasicInformation",
  mixins: [FormMixin],
  props: {
    preloader: {
      type: Boolean,
      default: false
    },
    basic_info: {
      type: Object,
      default: () => ({})
    },
    yesOrNoList: {
      type: Array,
      required: true
    },
    isAdmin: {
      type: Boolean,
      default: false
    },
    candidateId: {
      type: Number,
    },
  },
  data() {
    return {
      forename_error: false,
      employeeImagePreview: null, // URL for the image preview
      genderList: genderList,
      titleList: titleList,
      countryList: countryList,
      siaLicenseTypeList: siaLicenseTypeList,
      licenseOptions: siaLicenseTypeList,
      visaTypeList: visaTypeList,
      employmentDetailsTypeList: employmentDetailsTypeList,
      p46List: p46List,
      drivingLicenseTypeList: drivingLicenseTypeList,
      relationShipTypeList: relationShipTypeList,
      validationType: validationType,
      validation: {
        forename : true,
        middle_name : true,
        surname : true,
        driver_license_number: true,
        next_of_kin: true,
        relationship: true,
      },
      licenses: this.basic_info.licenses ?? [], // User added licenses
    };
  },

  computed: {
    today() {
      const today = new Date();
      const yyyy = today.getFullYear();
      const mm = String(today.getMonth() + 1).padStart(2, '0n'); // Months start at 0
      const dd = String(today.getDate()).padStart(2, '0');
      return `${yyyy}-${mm}-${dd}`;
    },
    availableLicenses() {
      if (this.licenses && Array.isArray(this.licenses)) {
        const selectedIds = this.licenses.map((l) => l.type);
        return this.licenseOptions.filter((opt) => !selectedIds.includes(opt.id));
      } else {
        return[{
          type: "",
          number: "",
          expiry: "",
          issueDate: "",
        }]; // Return an empty array or a default value if licenses is undefined
      }
    },
  },
  watch: {
    // Watch for changes in the licenses array to manage disabled options
    licenses: {
      handler(newVal) {
        if(newVal){
          // Reset all options
          this.licenseOptions.forEach((opt) => (opt.disabled = false));
          // Disable selected options
          newVal.forEach((license) => {
            this.updateLicenseOptions(license.type, true);
          });
        }
      },
      deep: true,
    },
    basic_info:{
      handler(newVal){
        this.licenses = Array.isArray(this.basic_info.licenses) ? this.basic_info.licenses : []
      },
      deep: true,
    }
  },
  methods: {
    licenseTypeFieldType(type){
      if (type === "drivingLicense" || type === 'nonFrontLine'|| type === 'others'){
        return 'text'
      }else{
        return 'number'
      }
    },
    addLicense() {
      if (this.availableLicenses ) {
        this.licenses.push({
          type: "",
          number: "",
          expiry: "",
          issueDate: "",
        });
      }
    },
    removeLicense(index) {
      this.licenses.splice(index, 1);
    },
    updateLicenseOptions(selectedType, isDisabled) {
      const license = this.licenseOptions.find((opt) => opt.id === selectedType);
      if (license) {
        license.disabled = isDisabled;
      }
      this.basic_info.licenses = this.licenses
    },
    validateAlphaNumericSixteenCharacter,
    validateAlphaNumeric,
    validateAlphabet,
    validateNumeric,

    employeePictureChange(event) {
      this.uploadBtnHandler(this.basic_info.employee_picture, 'profile_pic');
      const file = event.target.files[0];
      if (file) {
        // Create a URL for the image preview
        this.$set(this.basic_info.employeeImagePreview,'employeeImagePreview', URL.createObjectURL(file));

      }else if (this.basic_info.files){
        this.$set(this.basic_info.employeeImagePreview,'employeeImagePreview', this.basic_info.employee_picture);
      }
    },
    passportPictureChange(event) {
      this.uploadBtnHandler(this.basic_info.passport, 'passport');
      const file = event.target.files[0];
      if (file) {
        // Create a URL for the image preview
        this.$set(this.basic_info.employeeImagePreview,'passportPreview', URL.createObjectURL(file));
      }else if (this.basic_info.passport){
        this.$set(this.basic_info.passportPicture,'passportPreview', this.basic_info.passport);
      }
    },
    uploadBtnHandler(_file, _type, _issueDate = null, _expiryDate = null) {
      let data = {email: this.basic_info.email, type: _type, files: _file};
      if (_issueDate){
        data.issue_date = _issueDate
      }
      if (_expiryDate){
        data._expiryDate = _issueDate
      }
      let formData = new FormData;
      for (const [key, value] of Object.entries(data)) {
        formData.append(key, value);
      }
      File.uploadDocument(formData)
          .then((response) => {
            this.$toastr.s(response.data.message);
          })
          .catch(({error}) => {
            //trigger after error
          })
          .finally(() => {
            this.$hub.$emit("reload-" + this.tableId);
          });
    },
    textOnChange(event, model, validationType, length = null) {
          const text = event?.target.value;
      if (text) {
        if (validationType === this.validationType.AlphaNumeric16Characters) {
          this.validation[model] = this.validateAlphaNumericSixteenCharacter(text);
        }else if (validationType === this.validationType.AlphaNumeric) {
          this.validation[model] = this.validateAlphaNumeric(text);
        }else if (validationType === this.validationType.Alphabet) {
          this.validation[model] = this.validateAlphabet(text);
        }else if (validationType === this.validationType.Numeric) {
          const validationData = this.validateNumeric(text, length);
          this.validation[model] = validationData.isValid
          this.basic_info[model] = validationData.input
        }else if (validationType === this.validationType.Email) {
          this.validation[model] = this.validateEmail(text);
        }
        if(!this.validation[model]){
          // this.basic_info[field] = text.slice(0, -1);
          this.$set(this.basic_info, model, text.slice(0, -1));
          // event.preventDefault();
        }
        this.$set(this.validation, model, this.validation[model]);
      }
    }
  },
};
</script>

<style scoped>
hr{
  width: 100% !important
}
.error {
  color: red;
  font-weight: bold;
}
.form-with-table .h-100 {
  height: auto !important;
}
</style>